import { tv, VariantProps } from "@/utils";

export const spinner = tv({
  slots: {
    base: ["animate-spin"],
  },
  variants: {
    size: {
      sm: {
        base: "w-5 h-5",
      },
      md: {
        base: "w-8 h-8",
      },
      lg: {
        base: "w-10 h-10",
      },
    },
    color: {
      primary: {
        base: "text-primary-500",
      },
      secondary: {
        base: "text-secondary-500",
      },
      white: {
        base: "text-white",
      },
      black: {
        base: "text-black",
      },
    },
  },
  defaultVariants: {
    size: "sm",
  },
});

export type SpinnerVariantProps = VariantProps<typeof spinner>;

export type SpinnerReturnVariantProps = ReturnType<typeof spinner>;
